export const WS_BASE_URL = (() => {
    const protocol = (() => {
        if (window.location.protocol === 'https:') return 'wss:';
        return 'ws:';
    })();
    return `${protocol}//${window.location.host}/nalmon/websocket`;
})();
